/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
 $ = jQuery;

 (function($) {

 	var $body = $('body');
 	var $windowWidth = $(window).width();

 	scrollTop = function() {
 		$('.scroll--top').on('click', function(e){
 			e.preventDefault();
 			$('html,body').animate({
 				scrollTop: 0
 			});
 		});
 	};

 	scrollNext = function() {
 		$('.scroll--next').on('click', function(e){
 			e.preventDefault();
 			$('html,body').animate({
 				scrollTop: $($.attr(this, 'href') ).offset().top
 			});
 		});
 	};

 	scrollTabs = function() {
 		$('.scroll--tabs').on('click', function(e){
 			e.preventDefault();
 			var $target = $($(this).attr('data'));
 			var $header = $('.header');
 			$('html,body').animate({
 				scrollTop: $($.attr(this, 'href') ).offset().top - $header.height() - 24 +  'px'
 			});
 		});
 	};

 	toggleTabs = function() {
 		$('.toggle--tabs').on('click', function(e){
 			e.preventDefault();
 			$(this).toggleClass('show--tabs');
 			$('#tabs').toggleClass('show--tabs');
 		});
 	};

 	openModal = function() {
 		$('.open--modal').magnificPopup({
 			type: 'inline'
 		});

 		$('.open--tour').magnificPopup({
 			type: 'iframe',
 			closeOnBgClick: false,
 			enableEscapeKey: false
 		});
 	};

 	// openIframe = function() {
 	// 	$('.btn--order').magnificPopup({
 	// 		items: {              
 	// 			src: $('.btn--order').attr('href'),          
 	// 			type: 'iframe'
 	// 		}
 	// 	});
 	// };

 	openImageModal = function() {
 		$('.impression').magnificPopup({
 			delegate: 'a',
 			type: 'image',
 			mainClass: 'mfp-img-mobile',
 			gallery: {
 				enabled: true,
 				navigateByImgClick: true,
 				preload: [0,1] 
 			}
 		});
 	};

 	headerImage = function() {
 		$('.headerimage')
 		.slick({
 			dots: true,
 			customPaging : function(slider, i) {
 				return '<span></span>';
 			},
 			infinite: true,
 			slidesToShow: 1,
 			arrows: true,
 			lazyLoad: 'ondemand',
 			autoplay: true,
 			autoplaySpeed: 7000,
 			fade: true,
 			nextArrow: '<div class="slick-arrow slick-right icon-icon-arrow-right"></div>',
 			prevArrow: '<div class="slick-arrow slick-left icon-icon-arrow-left"></div>',
 			slidesToScroll: 1,
 			adaptiveHeight: false,
 			cssEase: 'linear'
 		})
 		.show();

 		if($('body').hasClass('home')) {
 			var infoHeight = $('.info').outerHeight(true);
 			if($windowWidth > 1139){
 				$('.headerimage__slide').css('min-height', 'calc(100vh - '+ infoHeight +'px)');
 			} else if ($windowWidth > 767) {
 				var totalHeight = infoHeight + 70;
 				$('.headerimage__slide').css('min-height', 'calc(100vh - '+ totalHeight +'px)');
 			} else {

 			}
 		}
 	};

 	/*----------  On scroll  ----------*/
 	$(window).scroll(function() {
 		stickyNavigation();
 	});

 	var waitForFinalEvent = (function () {
 		var timers = {};
 		return function (callback, ms, uniqueId) {
 			if (!uniqueId) {
 				uniqueId = "Don't call this twice without a uniqueId";
 			}
 			if (timers[uniqueId]) {
 				clearTimeout (timers[uniqueId]);
 			}
 			timers[uniqueId] = setTimeout(callback, ms);
 		};
 	})();

 	$(window).resize(function() {
 		waitForFinalEvent(function(){
 		}, 500);
 	});

 	$(document).ajaxComplete(function() {
 		$('select').select2({
 			minimumResultsForSearch: Infinity
 		});
 	});


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
  	'common': {
  		init: function() {
  			toggleNavigation();
  			toggleSubNav();
  			scrollMenu();
  			stickyNavigation();

  			scrollTop();
  			scrollTabs();

  			toggleTabs();

  			openModal();
  			openImageModal();
  			//openIframe();

  			headerImage();

  			$('select').select2({
  				minimumResultsForSearch: Infinity
  			});

  			var $grid = $('.infinite__scroll').imagesLoaded( function() {
  				var $gutterSize = 24;

  				$grid.isotope({
  					itemSelector: 'article',
  					masonry: {
  						gutter: $gutterSize
  					}
  				});
  				$grid.isotope();
  			});

  			var tabItems = $('#tabs').children().length;
  			if(tabItems < 2 ) {
  				$('.toggle--tabs').hide();
  			}

  		},
  		finalize: function() {
  		}
  	},
  	'home': {
  		init: function() {
  			scrollNext();
  		},
  		finalize: function() {
  		}
  	},
  	'page_template_contact_template': {
  		init: function() {
  			initMap();
  		}
  	}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
  	fire: function(func, funcname, args) {
  		var fire;
  		var namespace = Sage;
  		funcname = (funcname === undefined) ? 'init' : funcname;
  		fire = func !== '';
  		fire = fire && namespace[func];
  		fire = fire && typeof namespace[func][funcname] === 'function';

  		if (fire) {
  			namespace[func][funcname](args);
  		}
  	},
  	loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
      	UTIL.fire(classnm);
      	UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
  }
};

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
